import { FILTER_OPERATE_CONTAINER } from '@/pages/datalab/components/DashboardLayout/_config';
import { timeTypeObj } from '../components/RightModal/ExitModal/constant';
import { getLastDateRange } from "@/pages/datalab/utils/utils";
import { TableDataTab } from '../constants';

export const getLastItem = (list: Array<any>) => {
  let lastItem = null as any;
  list.forEach((item: any) => {
    const { x, y } = item;
    if (!lastItem) {
      lastItem = item;
    } else {
      const { x: lx, y: ly } = lastItem;
      if (y > ly || (y === ly && x >= lx)) {
        lastItem = item;
      }
    }
  });

  return lastItem;
};

export const getFirstItem = (list: Array<any>) => {
  let firstItem = null as any;
  list.forEach((item: any) => {
    const { x, y } = item;
    if (!firstItem) {
      firstItem = item;
    } else {
      const { x: fx, y: fy } = firstItem;
      if (y < fy || (y === fy && x < fx)) {
        firstItem = item;
      }
    }
  });

  return firstItem;
};

export const isFilterOperate = (id: string): boolean => id === FILTER_OPERATE_CONTAINER;

// 需先排除不是isFilterOperate
export const isFilter = (id: string): boolean => id?.startsWith('filter');

// 获取日期筛选器默认周期时间(默认日昨天)
export const getCycleTime = (defaultType: any = 'date', defaultValue: any = 'date1') => {
  // defaultValue是一个周期值
  const options = timeTypeObj?.[defaultType] || [];
  const newValue = options?.find((v: any) => v?.cycle === defaultValue)?.getValue();
  return [newValue?.[0]?.format('YYYY-MM-DD'), newValue?.[1]?.format('YYYY-MM-DD')];
};

export const getDateInfo = (value: [string, string?] | string, dateType: string, from: string, lastCount: number | string): {dateRange: [string, string]; dateType: string; lastCount?: number|string; buttonText?: string; from: string;} => {
  
  
  if (typeof value === 'string') { // 为了兼容早期旧数据
    const lastCount = value.replace(dateType, '');
    const newDateType = dateType === 'date' ? 'day' : dateType;
    return {
      lastCount: Number(lastCount), // 早期旧数据 lastCount需要时Number类型
      dateType: newDateType,
      dateRange: getLastDateRange(lastCount, newDateType, from),
      // buttonText: getDynamicDateText({lastCount, dateType: newDateType, formatMessage, from}),
      from: '1',
    };
  }
  
  const [start='', end] = value;
  if (end) return { // 如果end有值, 说明是静态时间
    dateRange: value,
    dateType,
  };
  
  let valueLastCount; // 为了兼容旧数据中没有lastCount的情况
  let newDateType;
  if (start.startsWith('-')) {
    valueLastCount = -1;
    newDateType = start?.replace('-', '')?.split('-')?.[1];
  } else {
    const arr = start?.split('-');
    valueLastCount = arr[0] ?? 7;
    // 旧数据中 如果 from为 '1', 代表昨天, 那么就把计算出来的lastCount转换成Number类型, 这样如果lastCount和固定选项的值相等, 那么才能选中固定选项,
    valueLastCount = from !== '1' ? valueLastCount : Number(valueLastCount);
    newDateType = arr[1];
  }
  const result = lastCount ?? valueLastCount;
  return {
    lastCount: result,
    dateType: newDateType,
    dateRange: getLastDateRange(result, newDateType, from),
    // buttonText: getDynamicDateText({lastCount, dateType: newDateType, formatMessage, from}),
    from: from ?? '1',
  };
};

export function safeParseBoolean(value) {
  if (value === 'false') {
    return false;
  } if (value === 'true') {
    return true;
  } if (value === undefined || value === null) {
    return undefined;
  } 
  try {
    return JSON.parse(value);
  } catch (e) {
    return undefined;
  }
}

export const getIsTemplatePageFn = (key: TableDataTab)=>[TableDataTab.Public,TableDataTab.Game].includes(key);


// 报表创建时, 获取show Conatact 的默认值
export const getShowContactDefault = (gameCode: string) => {
  const defaultCloseGameCodes = [
    'i_game', 'i_game_krafton', 'i_game_lite', 'pubgmitop_monitor', 'pubgm_meemo', 'pubgm_meemo_ASIA', 'pubgm_meemo_ME', 'pubgm_meemo_SEA'
  ];
  
  return !defaultCloseGameCodes.includes(gameCode);
};